export default "__VITE_ASSET__DoGTPEWw__"